import { DataService } from '../dataService';

const webBookServices = {
  getAllBookApi: (data) => {
    return DataService.get('author/book', data);
  },
  getSingleBookApi: (id) => {
    // return DataService.get(`author/book/${id}`);
    return DataService.get(`author/book-slug/${id}`);
  },
  getBookChapterHeaderApi: (id) => {
    return DataService.get(`author/book-chapters-headers-slug/${id}`);
  },

  // header get api author

  getAuthorPaginationApi: (id) => {
    return DataService.get(`/author/chapters-headers-sequence-slug/${id}`)
  },
  getChapterHeaderApi: (id, data) => {
    return DataService.get(`author/chapter/${id}`, data);
  },
  getHeaderOneApi: (id, data) => {
    return DataService.get(`author/header-1/${id}`, data);
  },
  getHeaderTwoApi: (id, data) => {
    return DataService.get(`author/header-2/${id}`, data);
  },
  getHeaderThreeApi: (id, data) => {
    return DataService.get(`author/header-3/${id}`, data);
  },

  // header create api author

  createChapterHeaderOneApi: (data) => {
    return DataService.post('author/header-1', data);
  },
  createChapterHeaderTwoApi: (data) => {
    return DataService.post('author/header-2', data);
  },
  createChapterHeaderThreeApi: (data) => {
    return DataService.post('author/header-3', data);
  },

  // header update api author

  updateChapterHeaderOneApi: (id, data) => {
    return DataService.put(`author/header-1/${id}`, data);
  },
  updateChapterHeaderTwoApi: (id, data) => {
    return DataService.put(`author/header-2/${id}`, data);
  },
  updateChapterHeaderThreeApi: (id, data) => {
    return DataService.put(`author/header-3/${id}`, data);
  },

  // header delete api author

  deleteChapterHeaderApi: (type, id, data) => {
    if (type == 'header-1') {
      return DataService.delete(`author/header-1/${id}`, data);
    }
    if (type == 'header-2') {
      return DataService.delete(`author/header-2/${id}`, data);
    }
    if (type == 'header-3') {
      return DataService.delete(`author/header-3/${id}`, data);
    }
  },

  swapChapter: (data) => {
    return DataService.patch('author/swap/chapter', data);
  },
  swapHeaderOne: (data) => {
    return DataService.patch('author/swap/header-1', data);
  },
  swapHeaderTwo: (data) => {
    return DataService.patch('author/swap/header-2', data);
  },
  swapHeaderThree: (data) => {
    return DataService.patch('author/swap/header-3', data);
  },

};

export default webBookServices;
